"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transitions = {
    easeOutFast: 'all 0.2s ease-out',
    easeOutSlow: 'all 0.4s ease-out',
};
exports.default = transitions;
